module.exports = __webpack_public_path__ + "static/media/ng.f9abfac2.svg";